import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Card, Link, Typography, Stack, Button, InputAdornment, TextField } from '@mui/material';
import Grid from '@mui/material/Grid'
import { useForm, Controller } from "react-hook-form";
// import blankImg from "../../../../public/assets/blank-img.jpg"
// Icons
import FastfoodOutlinedIcon from '@mui/icons-material/FastfoodOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';
import Label from '../../../components/label';
import { showSuccess, showError } from '../../../utils/toast';

// api
import { apiCallSecureGet, apiPostSecure, apiDeleteSecureWithBody, apiUrl } from '../../../utils/api';
import { useGetCategoryQuery, useGetSubCategoryQuery } from '../../../redux/services/common/Common';
import { useGetFoodUpdateMutation } from '../../../redux/services/seller/sellerInfo';



export const FoodMenuCreate = (props) => {
    const { create, title, message, setCreate, sellerid, setLoadMenu, reloadData } = props;
    const [selectedSubCategory, setSelectedSubCategory] = useState("");
    const { data: categorys } = useGetCategoryQuery()
    const { data: subcategory } = useGetSubCategoryQuery(selectedSubCategory)

    const [getCreatFood, CreatFood] = useGetFoodUpdateMutation()
    const [selectedCategory, setSelectedCategory] = useState("");


    const handleCategoryChange = (event) => {
        setSelectedCategory(event.target.value);
    };

    const handleSubCategoryChange = (event) => {
        setSelectedSubCategory(event.target.value);
    };
    const { register, handleSubmit, setValue, watch, control, reset, formState: { errors } } = useForm();

    const onAddFood = async (data, event) => {
        console.log("Add data", data)

        event.preventDefault();

        const formData = new FormData();
        formData.append('seller', sellerid);
        formData.append('name', data.name);
        formData.append('description', data.description);
        formData.append('category', data.category);
        formData.append('type', data.type);
        formData.append('thumb', data.thumb);
        formData.append('photo_1', data.photo_1);
        formData.append('photo_2', data.photo_2);

        console.log("thumb", data.thumb)
        console.log("photo_1", data.photo_1)
        console.log("photo_2", data.photo_2)

        console.log("Form data", formData)


        try {
            const addFood = await getCreatFood(formData)
            setCreate(addFood.data);
            console.log("addFood", addFood.data)
            setLoadMenu(true);
            setCreate(null);
            reset()
            reloadData()

        }
        catch (error) {
            console.error("Error fetching data:", error);
            showError('Error', error);

        }
    }


    useEffect(() => {
        if (CreatFood.isSuccess) {
            showSuccess('Food Creat Success', CreatFood.msg);
            CreatFood.reset();
        }
        if (CreatFood.isError) {
            showError('Error', CreatFood.msg);
            CreatFood.reset();
        }
    }, [CreatFood])


    return (
        <>
            <Dialog
                open={create != null}
                onClose={() => { setCreate(null) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>
                    <Typography variant='h4'>Add Food</Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {/* <Typography variant='h6'>{message?.current}</Typography> */}
                    </DialogContentText>
                    <br />
                    <br />
                    <form onSubmit={handleSubmit(onAddFood)}>

                        <Grid container spacing={1} mb={2}>
                            <Grid item xs={12} sm={6} md={4} >
                                <Controller
                                    name="thumb"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    <img
                                                        alt='img'
                                                        src="https://img.freepik.com/free-vector/illustration-cloud-upload_53876-35883.jpg?w=2000"
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                )}
                                            </div>
                                            <label htmlFor="thum" className="footer">
                                                <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M15.331 6H8.5v20h15V14.154h-8.169z" /><path d="M18.153 6h-.009v5.342H23.5v-.002z" /></g></svg>
                                                <p>Upload Img</p>

                                                <input
                                                    id='thum'
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                    style={{
                                                        display: "none",
                                                    }}

                                                />
                                            </label>
                                        </div>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Controller
                                    name="photo_1"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    <img
                                                        alt='img'
                                                        src="https://img.freepik.com/free-vector/illustration-cloud-upload_53876-35883.jpg?w=2000"
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                )}
                                            </div>
                                            <label htmlFor="photo1" className="footer">
                                                <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M15.331 6H8.5v20h15V14.154h-8.169z" /><path d="M18.153 6h-.009v5.342H23.5v-.002z" /></g></svg>

                                                <p>Upload Img</p>

                                                <input
                                                    // className='shop_Phot0'
                                                    id='photo1'
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                    style={{
                                                        display: "none",
                                                    }}

                                                />
                                            </label>
                                        </div>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Controller
                                    name="photo_2"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    <img
                                                        alt='img'
                                                        src="https://img.freepik.com/free-vector/illustration-cloud-upload_53876-35883.jpg?w=2000"
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                )}
                                            </div>
                                            <label htmlFor="photo2" className="footer">
                                                <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M15.331 6H8.5v20h15V14.154h-8.169z" /><path d="M18.153 6h-.009v5.342H23.5v-.002z" /></g></svg>
                                                <p>Upload Img</p>

                                                <input
                                                    // className='shop_Phot0'
                                                    id='photo2'
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                    style={{
                                                        display: "none",
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    )}
                                />

                            </Grid>
                        </Grid>
                        <Grid container spacing={1} mt={1} >
                            <Grid item xs={12} sm={6} md={6} mb={5}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                    <FastfoodOutlinedIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    <TextField fullWidth id="input-with-sx" label="Name" variant="standard"
                                        {...register("name", { required: 'select Food Name' })}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} mb={5}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                    <MenuBookOutlinedIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    <TextField fullWidth id="input-with-sx" label="Description" variant="standard" {...register("description", { required: 'Enter Food Description' })} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} mb={5}>

                                {/* <p>Selected Category ID: {selectedCategory}</p> */}

                                <TextField
                                    fullWidth
                                    select
                                    label="Select sub Category"
                                    // defaultValue="EUR"
                                    value={selectedSubCategory}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    {...register("subcategory", { required: 'select Food sub Category' })}
                                    variant="standard"
                                    onChange={handleSubCategoryChange}
                                >
                                    {categorys && categorys?.data?.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField
                                    fullWidth
                                    select
                                    label="Select Category"
                                    variant="standard"
                                    SelectProps={{
                                        native: true,
                                    }}
                                    {...register("category", { required: 'select Food Category' })}
                                    value={selectedCategory}
                                    onChange={handleCategoryChange}
                                >
                                    {subcategory && subcategory?.data?.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.name}
                                        </option>
                                    ))}

                                </TextField>
                                {/* <p>Selected Category ID: {selectedSubCategory}</p> */}

                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <TextField
                                    name='type'
                                    fullWidth
                                    select
                                    label="Select Type"
                                    {...register("type", { required: 'select type ' })}

                                    SelectProps={{
                                        native: true,
                                    }}
                                    variant="standard"
                                >
                                    <option value={'V'}>Veg</option>
                                    <option value={'N'}>NonVeg</option>
                                    <option value={'E'}>Egg</option>
                                </TextField>
                            </Grid>
                        </Grid>

                        <DialogActions>
                            <Button type="submit" >
                                Add
                            </Button>
                            <Button onClick={() => { setCreate(null) }}>Cancel</Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog >
        </>
    );
}


const options = [
    {
        value: 'banana',
        label: 'veg',
    },
    {
        value: 'chicken',
        label: 'non-veg',
    },
    {
        value: 'chocolet',
        label: 'egg',
    },

];

